<template>
	<div class="allstore">
		<div class="jubannerimg"><img :src="banner.image" @click="bannerTo(banner.url)"></div>
		<div class="allstorebox">
			<el-tabs v-model="pageName" @tab-click="handleClick" >
			    <el-tab-pane label="餐饮门店" name="canyin">
				</el-tab-pane>
			    <el-tab-pane label="零售门店" name="lingshou">
					<!--<div class="searchbox search2">-->
						<!--<div class="inline searchinner">-->
							<!--<el-input-->
							  <!--placeholder="输入门店查询"-->
							  <!--v-model="searchName"-->
							  <!--clearable>-->
							<!--</el-input>-->
						<!--</div>-->
						<!--<img src="../assets/images/icon-04.png" class="inline" />-->
					<!--</div>-->
					<!--<div class="storecontenbox">-->
						<!--<div class="storetop">-->
							<!--<div class="inline storetopleft">-->
								<!--<div class="storetitle">聚宝源&nbsp;悠唐店</div>-->
								<!--<div class="storetel">TEL:010-85306445</div>-->
								<!--<div class="storeaddress">北京朝阳区悠唐购物中心4F</div>-->
								<!--<div class="stroedetailaddress">BEI JING CHAO YANG <br/>YOU TANG GOU WU ZHONG XIN 4F</div>-->
								<!--<div class="iconimg">-->
									<!--<img src="../assets/images/icon-19.png" />-->
									<!--<img src="../assets/images/icon-20.png" />-->
									<!--<img src="../assets/images/icon-21.png" />-->
									<!--<img src="../assets/images/icon-22.png" />-->
									<!--<img src="../assets/images/icon-23.png" />-->
								<!--</div>-->
							<!--</div>-->
							<!--<div class="inline storerimg">-->
								<!--<img src="../assets/images/storeimg.png" />-->
							<!--</div>-->
						<!--</div>-->
						<!--<div class="mapbox">-->
							<!--<baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">-->
						    <!--&lt;!&ndash;缩放&ndash;&gt;-->
						        <!--<bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>-->
						        <!--&lt;!&ndash;定位&ndash;&gt;-->
						        <!--<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>-->
						        <!--&lt;!&ndash;点&ndash;&gt;-->
						        <!--<bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">-->
						        <!--</bm-marker>-->
						    <!--</baidu-map>-->
						<!--</div>-->
					<!--</div>-->
					<!--<div class="storecontenbox">-->
						<!--<div class="storetop">-->
							<!--<div class="inline storetopleft">-->
								<!--<div class="storetitle">聚宝源&nbsp;悠唐店</div>-->
								<!--<div class="storetel">TEL:010-85306445</div>-->
								<!--<div class="storeaddress">北京朝阳区悠唐购物中心4F</div>-->
								<!--<div class="stroedetailaddress">BEI JING CHAO YANG <br/>YOU TANG GOU WU ZHONG XIN 4F</div>-->
								<!--<div class="iconimg">-->
									<!--<img src="../assets/images/icon-19.png" />-->
									<!--<img src="../assets/images/icon-20.png" />-->
									<!--<img src="../assets/images/icon-21.png" />-->
									<!--<img src="../assets/images/icon-22.png" />-->
									<!--<img src="../assets/images/icon-23.png" />-->
								<!--</div>-->
							<!--</div>-->
							<!--<div class="inline storerimg">-->
								<!--<img src="../assets/images/storeimg.png" />-->
							<!--</div>-->
						<!--</div>-->
						<!--<div class="mapbox">-->
							<!--<baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">-->
							<!--&lt;!&ndash;缩放&ndash;&gt;-->
							    <!--<bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>-->
							    <!--&lt;!&ndash;定位&ndash;&gt;-->
							    <!--<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>-->
							    <!--&lt;!&ndash;点&ndash;&gt;-->
							    <!--<bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">-->
							    <!--</bm-marker>-->
							<!--</baidu-map>-->
						<!--</div>-->
					<!--</div>-->
					<!--<div class="pagebox">-->
						 <!--<el-pagination-->
						  <!--:total="10"-->
						  <!--prev-text='上一页'-->
						  <!--next-text='下一页'-->
						  <!--background-->
						  <!--:current-page.sync="currentPage"-->
						   <!--@current-change="handleCurrentChange"-->
						  <!--layout="prev, pager, next">-->
						<!--</el-pagination>-->
					<!--</div>-->
				</el-tab-pane>
			</el-tabs>
            <div class="searchbox ub ub-xc ub-ab">
                <div class="waplins">
                  <h2 v-text="pageTitle">零售门店</h2>
                  <p v-text="pageTitleEn">RETAIL STORES</p>
                </div>
                <div class="ub ub-xc ub-ab">
                  <div class="inline searchinner">
                    <el-input
                            placeholder="输入门店查询"
                            v-model="searchName"
                            clearable>
                    </el-input>
                  </div>
                  <img src="../assets/images/icon-04.png" class="inline" @click="handleClick"/>
                </div>
            </div>
            <div class="storecontenbox" v-for="item in list">
                <div class="storetop">
                    <div class="inline storetopleft">
                        <div class="storetitle">{{item.name}}</div>
                        <div class="storeaddress">{{item.address}}</div>
                        <div class="stroedetailaddress" v-html="item.address_en"></div>
                        <div class="storetel">TEL:{{item.phone}}</div>
                        <div class="iconimg">
                            <img :src="item.tag_image">
                            <!--<img src="../assets/images/icon-19.png" />-->
                            <!--<img src="../assets/images/icon-20.png" />-->
                            <!--<img src="../assets/images/icon-21.png" />-->
                            <!--<img src="../assets/images/icon-22.png" />-->
                            <!--<img src="../assets/images/icon-23.png" />-->
                        </div>
                    </div>
                    <div class="inline storerimg">
                        <img :src="item.image" />
                    </div>
                </div>
                <div class="mapbox">
                    <baidu-map class="map" :center="item.map.center" :zoom="item.map.zoom" @ready="handler">
                        <!--缩放-->
                        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                        <!--定位-->
                        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
                        <!--点-->
                        <bm-marker :position="item.map.center" :dragging="item.map.dragging" animation="BMAP_ANIMATION_DROP">
                        </bm-marker>
                    </baidu-map>
                </div>
            </div>
            <!--<div class="storecontenbox">-->
                <!--<div class="storetop">-->
                    <!--<div class="inline storetopleft">-->
                        <!--<div class="storetitle">聚宝源&nbsp;悠唐店</div>-->
                        <!--<div class="storetel">TEL:010-85306445</div>-->
                        <!--<div class="storeaddress">北京朝阳区悠唐购物中心4F</div>-->
                        <!--<div class="stroedetailaddress">BEI JING CHAO YANG <br/>YOU TANG GOU WU ZHONG XIN 4F</div>-->
                        <!--<div class="iconimg">-->
                            <!--<img src="../assets/images/icon-19.png" />-->
                            <!--<img src="../assets/images/icon-20.png" />-->
                            <!--<img src="../assets/images/icon-21.png" />-->
                            <!--<img src="../assets/images/icon-22.png" />-->
                            <!--<img src="../assets/images/icon-23.png" />-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="inline storerimg">-->
                        <!--<img src="../assets/images/storeimg.png" />-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="mapbox">-->
                    <!--<baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">-->
                        <!--&lt;!&ndash;缩放&ndash;&gt;-->
                        <!--<bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>-->
                        <!--&lt;!&ndash;定位&ndash;&gt;-->
                        <!--<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>-->
                        <!--&lt;!&ndash;点&ndash;&gt;-->
                        <!--<bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">-->
                        <!--</bm-marker>-->
                    <!--</baidu-map>-->
                <!--</div>-->
            <!--</div>-->
            <div class="pagebox">
                <el-pagination
                        :total="count"
                        prev-text='上一页'
                        next-text='下一页'
                        background
                        :page-size="3"
                        :current-page.sync="currentPage"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next">
                </el-pagination>
            </div>
		</div>

	</div>
</template>

<script>
export default {
    name: 'allStorse',
    watch:{
      $route(val){
  		  this.pageName = val.params.id;
          this.handleTypeChange();
          this.getStoreList();
  	  }
    },
    data () {
        return {
            pageName:'canyin',
            pageTitle:'',
            pageTitleEn:'',
            typeList:[{type:1,name:'canyin',title:'餐饮门店',title_en:'CATERING STORES'},
                {type:2,name:'lingshou',title:'零售门店',title_en:'RETAIL STORES'}],
            type:1,
            banner:[],
            list:[],
            currentPage:1,
            count:0,
            searchName:'',
//            map:{
//                    center: {lng: 121.4472540000, lat: 31.3236200000},
//                    zoom: 20,
//                    show: true,
//                    dragging: true
//                },
        }
    },
    mounted() {
        this.$nextTick(()=>{
            this.pageName = this.$route.params.id;
            this.getBanner();
            this.handleTypeChange();
            this.getStoreList();
            window.scrollTo(0,0);
        });

    },
    methods:{
        handleClick() {
            this.currentPage = 1;
            this.handleTypeChange();
            this.getStoreList();
        },
        handler ({BMap, map}) {

            //let me = this;
            console.log(BMap, map)
            // 鼠标缩放
            map.enableScrollWheelZoom(true);
            // var indoorManager = new BMapLib.IndoorManager(map);
            var marker = new BMap.Marker(map.PC)
            map.addOverlay(marker)
            // 点击事件获取经纬度
            map.addEventListener('click', function (e) {
                console.log(e.point.lng, e.point.lat)
            })
        },
        handleCurrentChange(){
            this.getStoreList();
            window.scrollTo(0, 0);
        },
        getBanner: async function () {
            const res = await this.$getJSON('/index/banner',{cat_id:8});
            this.banner = res.data.detail;
        },
        handleTypeChange: function () {
            for (let i=0;i<this.typeList.length;i++) {
                let typeObj = this.typeList[i];
                if(this.pageName == typeObj.name){console.log(this.pageName)
                    this.type = typeObj.type;
                    this.pageTitle = typeObj.title;
                    this.pageTitleEn = typeObj.title_en;
                }
            }
        },
        getStoreList: async function() {

            const res = await this.$getJSON('/index/storeList',{page:this.currentPage,type:this.type,keywords:this.searchName});
            this.list = res.data.list;
            this.count = res.data.count;
            for(var i=0;i<this.list.length;i++){
                var map = {
                    center: {lng: this.list[i]["longitude"], lat: this.list[i]["latitude"]},
                    zoom: 20,
                    show: true,
                    dragging: true
                }
                this.list[i]['map'] = map;
            }
        },
        bannerTo: function (url) {
            if(url === ""){
                return;
            } else if(url.substring(0, 1) == "/") {
                this.$router.push({path: url})
            } else {
                window.location.href = url;
            }
        }
    }
}
</script>

<style class="scoped">
	.map{
		height: 336px;
	}
	.mapbox{
		width: 100%;
		height: 336px;
		border-radius: 20px;
		overflow: hidden;
	}
	.el-pagination button, .el-pagination span:not([class*=suffix]) {
	    height: 28px;
	    padding: 5px 10px;
	    line-height: 20px;
	}
	.storerimg img{
		width: 584px;
		height: 350px;
		border-radius: 10px;
	}
	.storetitle{
		font-size: 40px;
		color: #9E856F;
		letter-spacing: 4px;
		height: 70px;
		vertical-align: text-top;
	}
	.storetel{
		font-size: 20px;
		letter-spacing: 2px;
		/* font-weight: 360; */
		font-family:"arial narrow";
		line-height: 50px;
	}
	.storeaddress{
		width: 90%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 20px;
		letter-spacing: 2px;
		line-height: 60px;

	}
	.stroedetailaddress{
		line-height: 18px;

	}
	.iconimg img{
		margin: 36px 20px 30px 0px;
        max-height: 65px;
	}
	.storecontenbox{
		margin: 50px 0px;
		padding-bottom: 70px;
		border-bottom: 1px solid #e8dfdd;
	}
	.storetop{
		margin-bottom: 50px;
	}
	.storetopleft{
		padding-left: 10px;
		box-sizing: border-box;
		text-align: left;
		width: 50%;
	}
	.searchbox{
		text-align: left;
	}
	.searchbox img{
		cursor: pointer;
	}
	.searchinner {
		width: 400px;
		margin-top: 50px;
		border-radius: 30px;
		margin-right: 20px;
		padding-bottom: 50px;
	}

	.allstorebox{
		width: 1200px;
		margin: 30px auto;
	}
	.allstore{
		margin-top: 20px;
	}
    .jubannerimg img{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/vew/allStores.vue